export default __webpack_public_path__ + "static/media/logo.e2c75eff.png";